import { useQuery } from "@apollo/client";
import { Modal } from "antd";
import React, { useState } from "react";
import { graphql } from "~/gql";

const EXISTING_DYNAMIC_TAG_IMAGES_QUERY = graphql(/* GraphQL */ `
  query existingDynamicTagImages {
    existingDynamicTagImages {
      name
      url
      width
      height
    }
  }
`);

type ExistingImageSelectorModalProps = {
  onSelect: (image: { name: string; url: string; width: number; height: number }) => void;
  open: boolean;
  onCancel: () => void;
};

export const ExistingImageSelectorModal = ({
  onSelect,
  open,
  onCancel,
}: ExistingImageSelectorModalProps) => {
  const { data } = useQuery(EXISTING_DYNAMIC_TAG_IMAGES_QUERY);
  const [selectedImage, setSelectedImage] = useState<{
    name: string;
    url: string;
    width: number;
    height: number;
  } | null>(null);

  return (
    <Modal
      title="Select Existing Image"
      open={open}
      onCancel={onCancel}
      width={900}
      centered
      footer={[
        <button key="cancel" onClick={onCancel} className="ant-btn" type="button">
          Cancel
        </button>,
        <button
          key="submit"
          onClick={() => {
            if (selectedImage) {
              onSelect(selectedImage);
            }
          }}
          className="ant-btn ant-btn-primary"
          type="button"
        >
          OK
        </button>,
      ]}
    >
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
            gap: "16px",
            padding: "16px",
            overflowY: "auto",
            flex: "1",
            minHeight: 0,
          }}
        >
          {data?.existingDynamicTagImages.map((image) => (
            <div
              key={image.name}
              onClick={() => setSelectedImage(image)}
              style={{
                cursor: "pointer",
                transition: "transform 0.2s",
                transform: selectedImage?.name === image.name ? "scale(1.02)" : "none",
                outline: selectedImage?.name === image.name ? "2px solid #1677ff" : "none",
                borderRadius: "8px",
              }}
            >
              <img
                src={image.url}
                alt={image.name}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "8px",
                  fontSize: "14px",
                  color: "rgba(0, 0, 0, 0.65)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {image.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
